module.exports = __webpack_public_path__ + "img/editIcon.9a090d89.svg";